import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthFetch } from "matsuri-hooks"
import {
    Proprietary,
    ProprietaryManualTypes,
    SortKeyOrder,
    convertManualTypesToRequest
} from "../domain/proprietary"
import { isGreaterScopeThan } from "../domain/authority"
import { m2mCore } from "../endpoints/m2m-core"
import { m2mCore_v1 } from "../endpoints/m2m-core.v1"
import { useAuthUser } from "./useAuthUser"

export const useProprietary = (token: string, proprietaryId: string) => {
    return useAuthFetch<Proprietary>(
        token,
        m2mCore.v1.getProprietary({ id: proprietaryId }),
        {}
    )
}

export const useSearchProprietaries = (
    token: string,
    input: {
        conditions: {
            manualTypeQuery: ProprietaryManualTypes
            startDateSince?: string
            endDateSince?: string
        }
        pagination: {
            page: number
            itemsPerPage: number
        }
        sortOrder?: SortKeyOrder
    }
) => {
    return useAuthFetch<{ proprietaries: Proprietary[]; total: number }>(
        token,
        m2mCore_v1.searchTemporaryBlockProprietaries(), // TODO: バッジの挙動大丈夫そうか確認
        {
            method: "POST",
            body: JSON.stringify({
                conditions: {
                    ...input.conditions,
                    manualTypeQuery: convertManualTypesToRequest(
                        input.conditions.manualTypeQuery
                    )
                },
                pagination: {
                    ...input.pagination
                },
                sortOrder: input.sortOrder
            })
        }
    )
}

export const useModifyProprietary = () => {
    const { token } = useAuth()
    const jwt = useAuthUser(token)

    if (!jwt) {
        return false
    }

    return isGreaterScopeThan(jwt.scope.calendars, "write")
}
